import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

const WelcomePage = lazy(() => import('./WelcomePage'));
const LoginPage = lazy(() => import('./LoginPage'));
const SignupPage = lazy(() => import('./SignupPage'));
const ChatPage = lazy(() => import('./ChatPage'));
const HistoryPage = lazy(() => import('./HistoryPage'));
const ProfilePage = lazy(() => import('./ProfilePage'));
const SettingsPage = lazy(() => import('./SettingsPage'));
const PricingPage = lazy(() => import('./PricingPage'));
const AboutPage = lazy(() => import('./AboutPage'));
const PrivacyPage = lazy(() => import('./PrivacyPage'));
const TermsPage = lazy(() => import('./TermsPage'));
const NotFoundPage = lazy(() => import('./NotFoundPage'));
const DiscoverPage = lazy(() => import('./DiscoverPage'));
const UseCasesPage = lazy(() => import('./UseCasesPage'));
const UseCaseDetailPage = lazy(() => import('./UseCaseDetailPage'));
const AdminLogin = lazy(() => import('./AdminLogin'));
const AdminDashboard = lazy(() => import('./AdminDashboard'));
const AdminUsers = lazy(() => import('./AdminUsers'));
const AdminHistory = lazy(() => import('./AdminHistory'));
const AdminPayments = lazy(() => import('./AdminPayments'));
const AdminInsights = lazy(() => import('./AdminInsights'));
const PurchasePage = lazy(() => import('./PurchasePage'));
const PaymentsPage = lazy(() => import('./PaymentsPage'));

const RouteLoader = () => (
  <div className="min-h-screen bg-lemon-chiffon dark:bg-gray-900 flex items-center justify-center">
    <p className="text-ultra-violet dark:text-white font-mono">Loading...</p>
  </div>
);

function App() {
  return (
    <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <Suspense fallback={<RouteLoader />}>
        <Routes>
          <Route path="/" element={<ChatPage />} />
          <Route path="/chat" element={<ChatPage />} />
          <Route path="/welcome" element={<WelcomePage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/signup" element={<SignupPage />} />
          <Route path="/history" element={<HistoryPage />} />
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/settings" element={<SettingsPage />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/discover" element={<DiscoverPage />} />
          <Route path="/use-cases" element={<UseCasesPage />} />
          <Route path="/use-cases/:slug" element={<UseCaseDetailPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/admin/users" element={<AdminUsers />} />
          <Route path="/admin/history" element={<AdminHistory />} />
          <Route path="/admin/payments" element={<AdminPayments />} />
          <Route path="/admin/insights" element={<AdminInsights />} />
          <Route path="/purchase" element={<PurchasePage />} />
          <Route path="/payments" element={<PaymentsPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Suspense>
    </Router>
  );
}

export default App;
